import { Key } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import {
  PageHeader,
  SwitchCard,
  SimpleErrorNotification,
  ViewSubSection,
} from "shared/components";
import { Flex } from "styled-system/jsx";
import { useBackOffice } from "./useBackOffice";
import { OperatorNotes } from "./OperatorNotes";
import { useOperatorContext } from "apps/directory/Operator";
import { UnpublishCard } from "./UnpublishCard";
import { DeleteCard } from "./DeleteCard";
import { BackOfficeTags } from "./BackOfficeTags";

export const BackOffice = () => {
  const { t } = useTranslation();
  const { operatorEntityId, organizationId } = useParams();
  const { operator } = useOperatorContext();

  const { onUpdateOrganizationControlled, currentEnrollment } = useBackOffice(
    operator,
    operatorEntityId,
    organizationId,
  );

  return (
    <Flex flexDir={"column"} gap={"500"}>
      <PageHeader
        title={t("directory:OPERATOR.BACK_OFFICE.TITLE")}
        description={t("directory:OPERATOR.BACK_OFFICE.DESCRIPTION")}
        Icon={Key}
      />
      {/* Back office tags: */}
      <BackOfficeTags
        operator={operator}
        operatorEntityId={operatorEntityId}
        organizationId={organizationId}
      />

      {/* Private notes section: */}
      <OperatorNotes
        organizationId={organizationId}
        operatorEntityId={operatorEntityId}
      />

      {/* Profile Management section: */}
      <ViewSubSection
        title={t("directory:OPERATOR.BACK_OFFICE.PROFILE_MANAGEMENT.TITLE")}
        description={t(
          "directory:OPERATOR.BACK_OFFICE.PROFILE_MANAGEMENT.DESCRIPTION",
        )}
      >
        {currentEnrollment ? (
          <SwitchCard
            title={t(
              "directory:OPERATOR.BACK_OFFICE.PROFILE_MANAGEMENT.FORM_LABEL",
            )}
            checked={currentEnrollment.organizationControlled}
            onCheckedChange={onUpdateOrganizationControlled}
          />
        ) : (
          <SimpleErrorNotification />
        )}
      </ViewSubSection>

      {/* Visibility Status section: */}
      <ViewSubSection
        title={t("directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.TITLE")}
      >
        <UnpublishCard />
        <DeleteCard />
      </ViewSubSection>
    </Flex>
  );
};
